import http, { HttpFactory } from "utils/http";
import { xhrCache } from "utils/cache";
import { diInject } from "stores/diContext";

export class SplashpageService {

    @diInject("api") http: HttpFactory;

    get(id) {

        var req_id = "get_splashpage",
            cache_id = "splashpage_cache_" + id;

        return xhrCache.get(req_id, () => this.http.url(`/splashpages/${id}`))
            .stop()
            .cache(cache_id, (_http) => {
                return _http.get();
            });
    }
}


// WEBPACK FOOTER //
// ./src/Apps/ticketing/services/splashpage.ts